import { render } from "./ResultModule.vue?vue&type=template&id=2b73d63b"
import script from "./ResultModule.vue?vue&type=script&lang=js"
export * from "./ResultModule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__